import styled from 'styled-components';

import { CSelect } from 'components';

export const CustomSelect = styled(CSelect)`
  .ant-select-selector {
    border-radius: 6px 0px 0px 6px !important;
  }

  z-index: 1;
  /* :hover {
    border-right: 1px solid ${p => p.theme.colors.primary.main};
  }
  :focus {
    border-right: 1px solid ${p => p.theme.colors.primary.main};
  } */
`;

export const Wrapper = styled.div`
  .ant-input-affix-wrapper {
    border-radius: 0px 6px 6px 0px !important;
  }
`;

export const WrapperStatus = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  position: relative;
  > div {
    padding-right: 23px;
  }
`;

export const WrapperIcon = styled.span`
  position: absolute;
  right: 5px;
  font-size: ${props => props.theme.font.size.tiny};
  color: #575757;
  &:hover {
    cursor: pointer;
  }
`;
